import { render } from "./esg.vue?vue&type=template&id=bf7f8b32"
import script from "./esg.vue?vue&type=script&lang=js"
export * from "./esg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__